import React from "react";
import "../App.css";
import carbon from "../assets/carbon.png";

export default function EventCarbon() {
  return (
    <section className="container my-5">
      <div className="row align-items-center g-4">
        {/* Left Text */}
        <div className="col-md-6">
          <h3
            className="fw-bold"
            style={{
              color: "#063970",
              fontWeight: "bold",
              fontFamily: "Oswald, sans-serif",
            }}
          >
            YPO Event Carbon Footprint
          </h3>
          <p className="text-muted">
            As part of our commitment to sustainability and responsible
            leadership, YPO / YNG is proud to introduce the Flight Carbon
            Calculator for the upcoming Global Impact Summit (GIS) in Manaus,
            Amazon, Brazil.
          </p>
          <p className="text-muted">
            This tool allows all summit attendees to measure the carbon
            footprint of their flights to and from Brazil and offset it through
            verified, high-impact carbon projects.
          </p>
        </div>

        {/* Right Image */}
        <div className="col-md-6 text-center">
          <div className="position-relative">
            <img
              src={carbon}
              alt="Event Carbon"
              className="img-fluid rounded shadow"
              style={{
                borderRadius: "10px",
                border: "5px solid #ffffff", // white border
              }}
            />
            {/* Decorative Circle */}
            <div
              className="position-absolute top-0 end-0 translate-middle bg-white rounded-circle"
              style={{ width: "80px", height: "80px" }}
            ></div>
            {/* Decorative Dotted Line */}
            <div
              className="position-absolute bottom-0 start-0 translate-middle"
              style={{
                width: "100px",
                height: "100px",
                border: "2px dashed #0b3b5e",
                borderRadius: "50%",
              }}
            ></div>
          </div>
        </div>
      </div>
    </section>
  );
}
